/**
 * Eingabemaske für die Pflege-KI · alle Sektionen.
 * Quick-Picks (Chip-Checkboxen) fügen Standard-Phrasen ins Freitext-Feld ein,
 * damit Pflegekräfte nicht alles tippen müssen.
 */

const QUICK_PICKS = {
  // ───── Pflegesituation ─────
  "pflegesituation.mobilitaet": [
    "Selbstständig gehfähig", "Rollator", "Rollstuhl",
    "Hilfe beim Aufstehen", "Hilfe beim Transfer",
    "Treppen erschwert", "Sturzrisiko", "Bettlägerig",
  ],
  "pflegesituation.kognition": [
    "Vollständig orientiert",
    "Zeitlich teilweise desorientiert", "Örtlich teilweise desorientiert",
    "Vergisst Termine", "Vergisst Medikamente",
    "Erkennt Angehörige", "Erkennt Angehörige teilweise nicht",
    "Demenz bekannt",
  ],
  "pflegesituation.verhalten": [
    "Wach und freundlich", "Antriebslos", "Unruhe abends",
    "Nächtliche Unruhe", "Ängstlich",
    "Verweigert Pflege gelegentlich", "Hinlauftendenz",
  ],
  "pflegesituation.selbstversorgung": [
    "Vollständig selbstständig",
    "Hilfe beim Duschen", "Hilfe beim Waschen",
    "Hilfe beim Anziehen Oberkörper", "Hilfe beim Anziehen Unterkörper",
    "Hilfe beim Essen", "Hilfe beim Trinken",
    "Hilfe beim Toilettengang",
  ],
  "pflegesituation.ernaehrung": [
    "Isst selbstständig", "Appetit reduziert",
    "Trinkmenge zu gering", "Diabetes-Kost",
    "Pürierte Kost", "Schluckstörung", "Gewichtsverlust",
  ],
  "pflegesituation.ausscheidung": [
    "Kontinent", "Harninkontinenz", "Stuhlinkontinenz",
    "Trägt Vorlagen tagsüber", "Trägt Vorlagen nachts",
    "Blasen-DK", "Stoma",
  ],
  "pflegesituation.krankheit_therapie": [
    "Hypertonie", "Diabetes mellitus", "Demenz",
    "Z. n. Apoplex", "Parkinson", "Herzinsuffizienz",
    "COPD", "Niereninsuffizienz", "Krebs / Tumor",
  ],
  "pflegesituation.alltagsleben": [
    "Aktiv und selbstorganisiert",
    "Benötigt Erinnerung an Termine", "Benötigt Erinnerung an Mahlzeiten",
    "Sozial isoliert", "Hobbies vorhanden", "Tagespflege besucht",
  ],
  "pflegesituation.haushaltsfuehrung": [
    "Vollständig selbstständig", "Hilfe bei Einkauf",
    "Hilfe bei Wäsche", "Hilfe beim Kochen", "Komplette Übernahme",
  ],
  // ───── Risiken (single-line inputs) ─────
  "risiken.sturz": ["niedrig", "mittel", "hoch", "Sturz in den letzten 4 Wochen", "Mehrere Beinahe-Stürze"],
  "risiken.dekubitus": ["niedrig", "mittel", "hoch", "Braden 14", "Rötung Sakral", "Bettlägerig"],
  "risiken.schmerz": ["NRS 2", "NRS 4", "NRS 6", "Belastungsschmerz", "Ruheschmerz"],
  "risiken.mangelernaehrung": ["niedrig", "mittel", "hoch", "Gewichtsverlust 3 kg / 3 Mon."],
  "risiken.dehydration": ["niedrig", "mittel", "Trinkmenge < 1000 ml", "trockene Schleimhäute"],
  "risiken.inkontinenz": ["tagsüber", "nachts", "vollständig", "Vorlagen", "Blasen-DK"],
  "risiken.medikamente": ["niedrig", "Wechselwirkung möglich", "Compliance-Problem", "BTM"],
  "risiken.wundrisiko": ["keiner", "Pergamenthaut", "Ulcus cruris", "Druckstelle Sakral"],
  // ───── Behandlungspflege (Quick-Phrasen) ─────
  "behandlungspflege.medikamente": [
    "Stellen 1x täglich", "Anreichen 2x täglich",
    "Insulin s.c.", "BTM", "Tropfen morgens",
  ],
  "behandlungspflege.blutzucker": ["BZ 1x täglich", "BZ 2x täglich", "Nüchtern + abends"],
  "behandlungspflege.injektionen": ["Insulin s.c.", "Heparin s.c.", "Vit-B12 i.m."],
  "behandlungspflege.kompression": ["Kompression Klasse II", "Kurzzug links", "Beidseits"],
  "behandlungspflege.vitalwerte": ["RR 1x wöchentlich", "RR 2x wöchentlich", "Puls + RR täglich"],
};


const SECTIONS = [
  {
    id: "kundendaten",
    title: "Kundendaten",
    fields: [
      ["kundennummer", "Kundennummer / Testname", "input", "TK-001 oder Anonymname"],
      ["alter", "Alter", "number", "z. B. 82"],
      ["pflegegrad", "Pflegegrad", "number", "0–5"],
      ["wohnsituation", "Wohnsituation", "textarea", "Lebensumstände, häusliche Situation"],
      ["angehoerige", "Angehörige / Bezugspersonen", "textarea", "Wer ist beteiligt, Verfügbarkeit?"],
      ["versorgungsziel", "Versorgungsziel", "textarea", "Was soll die Pflege erreichen?"],
    ],
  },
  {
    id: "pflegesituation",
    title: "Pflegesituation",
    fields: [
      ["mobilitaet", "Mobilität", "textarea", "Gehen, Transfer, Hilfsmittel, Sicherheit"],
      ["kognition", "Kognition / Kommunikation", "textarea", "Orientierung, Sprache, Gedächtnis"],
      ["verhalten", "Verhalten / Psychische Situation", "textarea", "Unruhe, Antrieb, Stimmung"],
      ["selbstversorgung", "Selbstversorgung", "textarea", "Körperpflege, An- und Auskleiden"],
      ["ernaehrung", "Ernährung / Flüssigkeit", "textarea", "Appetit, Trinkmenge, Hilfen"],
      ["ausscheidung", "Ausscheidung", "textarea", "Kontinenz, Hilfsmittel"],
      ["krankheit_therapie", "Umgang mit Krankheit / Therapie", "textarea", "Diagnosen, Therapie, Compliance"],
      ["alltagsleben", "Alltagsleben / Soziale Kontakte", "textarea", "Tagesstruktur, Kontakte, Hobbys"],
      ["haushaltsfuehrung", "Haushaltsführung", "textarea", "Kochen, Waschen, Einkauf"],
    ],
  },
  {
    id: "risiken",
    title: "Risiken",
    fields: [
      ["sturz", "Sturzrisiko", "input", "niedrig / mittel / hoch + Hinweise"],
      ["dekubitus", "Dekubitusrisiko", "input", "Braden-Score, Lokalisation"],
      ["schmerz", "Schmerz", "input", "NRS, Lokalisation, Auslöser"],
      ["mangelernaehrung", "Mangelernährung", "input", "Gewicht, Verlauf, BMI"],
      ["dehydration", "Dehydration", "input", "Trinkmenge, Hautturgor"],
      ["inkontinenz", "Inkontinenz", "input", "Tag/Nacht, Versorgung"],
      ["medikamente", "Medikamentenrisiko", "input", "Wechselwirkung, Compliance"],
      ["wundrisiko", "Wundrisiko", "input", "Lokalisation, Stadium, Verlauf"],
      ["weitere", "Weitere Risiken", "textarea", "Frei ergänzbar"],
    ],
  },
  {
    id: "behandlungspflege",
    title: "Behandlungspflege",
    fields: [
      ["medikamente", "Medikamente", "textarea", "Richten, Anreichen, Schema"],
      ["blutzucker", "Blutzucker", "input", "Frequenz, Zielwerte"],
      ["injektionen", "Injektionen", "input", "Substanz, Frequenz"],
      ["kompression", "Kompression", "input", "Klasse, Lokalisation"],
      ["wundversorgung", "Wundversorgung", "textarea", "Lokalisation, Verbandwechsel, Plan"],
      ["vitalwerte", "Vitalwerte", "input", "RR, Puls, Frequenz"],
      ["aerztliche_verordnungen", "Ärztliche Verordnungen", "textarea", "Welche VO liegen vor?"],
      ["sonstige", "Sonstige Leistungen", "textarea", "Weitere SGB-V- / SGB-XI-Leistungen"],
    ],
  },
  {
    id: "freitext",
    title: "Freitext / Beobachtungen",
    fields: [
      ["beobachtungen", "Beobachtungen", "textarea", "Was fällt auf? Veränderungen?"],
      ["besonderheiten", "Besonderheiten", "textarea", "Allergien, kulturelle Aspekte, Vorlieben"],
      ["wuensche", "Wünsche des Kunden", "textarea", "Was sagt die Kundin / der Kunde selbst?"],
      ["hinweise_angehoerige", "Hinweise der Angehörigen", "textarea", "Was berichten Bezugspersonen?"],
      ["einschaetzung", "Einschätzung der Pflegefachkraft", "textarea", "Fachliche Bewertung, Indikation"],
    ],
  },
];


/** Quick-Pick-Logik: toggelt eine Phrase im Freitext. */
function togglePhrase(currentText, phrase, isTextarea) {
  const txt = String(currentText || "");
  if (txt.toLowerCase().includes(phrase.toLowerCase())) {
    // Entferne die Phrase (mit umliegenden Trennern)
    const regex = new RegExp(
      `(\\.\\s*)?${phrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(\\.?\\s*)?`,
      "i",
    );
    return txt.replace(regex, "").replace(/\s*\.\s*\./g, ".").trim();
  }
  // Anhängen
  if (!txt.trim()) return phrase + (isTextarea ? "." : "");
  if (isTextarea) {
    const sep = txt.endsWith(".") || txt.endsWith(",") || txt.endsWith(";") ? " " : ". ";
    return txt + sep + phrase + ".";
  }
  // Input: Komma-getrennt
  return txt + (txt.endsWith(",") ? " " : ", ") + phrase;
}


function QuickPicks({ section, field, picks, currentValue, onChange, isTextarea, sectionId }) {
  if (!picks || picks.length === 0) return null;
  const active = (phrase) =>
    String(currentValue || "").toLowerCase().includes(phrase.toLowerCase());
  return (
    <div className="flex flex-wrap gap-1.5 mb-1.5" data-testid={`pki-quickpicks-${sectionId}-${field}`}>
      {picks.map((p) => {
        const isOn = active(p);
        return (
          <button
            key={p}
            type="button"
            onClick={() => onChange(togglePhrase(currentValue, p, isTextarea))}
            data-testid={`pki-chip-${sectionId}-${field}-${p.replace(/[^a-zA-Z0-9]+/g, "_").toLowerCase()}`}
            className={`inline-flex items-center gap-1 h-7 rounded-full border text-[11.5px] font-medium px-2.5 transition-colors ${
              isOn
                ? "bg-sand-800 text-cream-50 border-sand-800"
                : "bg-cream-50 text-sand-700 border-cream-300 hover:border-terra hover:bg-white"
            }`}>
            <span className="text-[10px]">{isOn ? "✓" : "+"}</span>
            {p}
          </button>
        );
      })}
    </div>
  );
}


export default function PkiInputForm({ input, setInput, customerLabel, setCustomerLabel }) {
  const update = (section, field, value) => {
    setInput((prev) => ({
      ...prev,
      [section]: { ...(prev[section] || {}), [field]: value },
    }));
  };

  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-cream-300 bg-white p-5">
        <label className="block text-[11px] uppercase tracking-[0.22em] font-semibold text-sand-500 mb-1.5">
          Bezugslabel (optional)
        </label>
        <input
          value={customerLabel || ""}
          onChange={(e) => setCustomerLabel(e.target.value)}
          placeholder="z. B. Testkundin 1 · Demenz, PG 3"
          data-testid="pki-customer-label"
          className="w-full h-11 rounded-xl border border-cream-300 bg-cream-50 px-3 text-[14px] text-sand-800 focus:outline-none focus:border-terra"
        />
        <p className="mt-1.5 text-[12px] text-sand-500">
          Wird in Entwürfe & PDF-Export übernommen – keine echten Klarnamen verwenden.
        </p>
      </div>

      <div className="rounded-2xl border border-terra/30 bg-peach-50 p-4 text-[12.5px] text-sand-700 leading-snug">
        <strong className="text-brand-darkred">Schneller eingeben:</strong> Klicke unten
        die passenden <em>Schnellauswahl-Chips</em> an — der Text landet automatisch
        im Freitext-Feld. Einzelne Wörter kannst du nachträglich anpassen.
      </div>

      {SECTIONS.map((sec) => (
        <div key={sec.id} data-testid={`pki-section-${sec.id}`}
          className="rounded-2xl border border-cream-300 bg-white p-5">
          <div className="text-[10.5px] uppercase tracking-[0.28em] font-bold text-clay-dark mb-4">
            {sec.title}
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            {sec.fields.map(([field, label, type, placeholder]) => {
              const key = `${sec.id}.${field}`;
              const picks = QUICK_PICKS[key];
              const isTextarea = type === "textarea";
              const currentValue = input[sec.id]?.[field];
              return (
                <div key={field} className={isTextarea ? "md:col-span-2" : ""}>
                  <label className="block text-[12px] font-medium text-sand-600 mb-1.5">
                    {label}
                  </label>
                  {picks && (
                    <QuickPicks
                      sectionId={sec.id}
                      section={sec.id}
                      field={field}
                      picks={picks}
                      currentValue={currentValue}
                      isTextarea={isTextarea}
                      onChange={(val) => update(sec.id, field, val)}
                    />
                  )}
                  {isTextarea ? (
                    <textarea
                      rows={2}
                      value={currentValue || ""}
                      onChange={(e) => update(sec.id, field, e.target.value)}
                      placeholder={picks ? "Weitere Hinweise / Freitext …" : placeholder}
                      data-testid={`pki-${sec.id}-${field}`}
                      className="w-full rounded-xl border border-cream-300 bg-cream-50 px-3 py-2 text-[13.5px] text-sand-800 focus:outline-none focus:border-terra resize-y"
                    />
                  ) : (
                    <input
                      type={type}
                      value={currentValue ?? ""}
                      onChange={(e) => {
                        const val = type === "number"
                          ? (e.target.value ? Number(e.target.value) : "")
                          : e.target.value;
                        update(sec.id, field, val);
                      }}
                      placeholder={picks ? "Weitere Hinweise / Freitext …" : placeholder}
                      data-testid={`pki-${sec.id}-${field}`}
                      className="w-full h-10 rounded-xl border border-cream-300 bg-cream-50 px-3 text-[13.5px] text-sand-800 focus:outline-none focus:border-terra"
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}

      <p className="text-[12px] text-sand-500">
        Fülle so viel wie möglich aus – die KI nutzt nur die übergebenen Felder.
        Leere Felder werden ignoriert. Bei fehlenden Angaben antwortet die KI mit &bdquo;Offene Punkte / R&uuml;ckfragen&ldquo;.
      </p>
    </div>
  );
}
